var BaseView = require('./abstract/base');
var TypeEffect = require('./components/type-effect');
var humps = require('../../../../utils/humps');
var AppDecorate = require('../../../../app/decorate');
var DesignFacade = require('../../../../facade/design/design');
var AnalyticsDecorate = require('../../../../analytics/decorate');
var EditorFacade = require('../../../../facade/editor/editor');

module.exports = AnalyticsDecorate(require('./analytics/text'), AppDecorate(require('./app/text'), BaseView.extend({
  template: require('./templates/template-text.hbs'),
  width: null,
  height: null,

  events: _.extend({
    'click a.toggle-options': 'toggleOptionsEvent',
    'click  .btn.begin-edit': 'startEditingEvent',
    'blur .line-container input': 'endEditingEvent',
    'keyup .line-container input': 'keyupEvent',
    'keydown .line-container input': 'keydownEvent',
    'click .options .fonts-list': 'displayFontFamiliesEvent',
    'click .options .bold-font a': 'toggleBoldFontEvent',
    'click .options .italic-font a': 'toggleItalicFontEvent',
    'click .options .underline-font a': 'toggleUnderlineFontEvent',
    'click .options .fonts-list .ui-dropdown-items a': 'changeFontFamilyEvent'
  }, BaseView.prototype.events),

  changeFontFamilyEvent: function (event) {
    var $text = this.$el.find('.line-container > .item');
    var $options = this.$el.find('.options');
    var fontFamily = $(event.currentTarget).css('font-family');

    $text.css({
      'font-family': fontFamily,
      'font-weight': '',
      'font-style': '',
      'text-decoration': ''
    });

    $options.find('.fonts-list .ui-dropdown-title').text(this.getQuoteScaped(fontFamily));
    $options.find('.btn-onmenu').removeClass('applied');
    this.toggleFontAvailableOptions($(event.currentTarget).data('fontid'));

    this.trigger('change');
  },

  getQuoteScaped: function (fontFamily) {
    return fontFamily.replace(/^['|"](.*)['|"]$/, function (initial, data) {
      return data;
    });
  },

  toggleBoldFontEvent: function (event) {
    this.cssToggle(event, 'font-weight', 'bold');

    !this.currentFont.support.bi && this.currentFont.support.i && this.$el
      .find('.options .italic-font')
      .toggleClass('disabled', $(event.currentTarget).hasClass('applied'));
  },

  toggleItalicFontEvent: function (event) {
    this.cssToggle(event, 'font-style', 'italic');

    !this.currentFont.support.bi && this.currentFont.support.b && this.$el
      .find('.options .bold-font')
      .toggleClass('disabled', $(event.currentTarget).hasClass('applied'));
  },

  toggleUnderlineFontEvent: function (event) {
    this.cssToggle(event, 'text-decoration', 'underline');
  },

  cssToggle: function (event, attrName, value) {
    var $text = this.$el.find('.line-container > .item');
    var $target = $(event.currentTarget).toggleClass('applied');

    $text.css(attrName, $target.hasClass('applied') ? value : '');
    this.trigger('change');
  },

  clickEvent: function (event) {
    var isEditing = this.isBeingEdit();
    isEditing || this.addElement(this.getClickElementData(event));
  },

  mouseUpEvent: function (event) {
    var isEditing = this.isBeingEdit();
    isEditing || this.addElement(this.getMouseUpElementData(event));
  },

  toggleOptionsEvent: function (event) {
    var currentHeight = this.$el.height();
    var hasOpenOptionsMenu = currentHeight > this.minimizedHeight;
    var isEditing = this.isBeingEdit();
    $(event.currentTarget).toggleClass('active');

    hasOpenOptionsMenu || this.startEditingEvent();
    hasOpenOptionsMenu && this.$el.css('overflow', 'hidden');
    hasOpenOptionsMenu && isEditing && this.blurEditableContent();

    this.$el.height(hasOpenOptionsMenu
      ? this.minimizedHeight
      : this.fullHeight
    );
  },

  keydownEvent: function (event) {
    if (event.which === 13) {
      event.preventDefault();
      this.blurEditableContent();
    }
  },

  keyupEvent: function (event) {
    if (!this.data['text_block']) {
      var text = this.$el.find('.line-container input').val() || '&nbsp;';
      this.$el.find('.line-container > .item .content').html(text);
    }
  },

  blurEditableContent: function () {
    this.$el.find('.line-container input').blur();
  },

  startEditingEvent: function (event) {
    var now = new Date();
    if (now - this.editEndTime < 1000) return;

    this.preEditText = this.$el.find('.line-container > .item .content').text();
    var $input = this.$el.find('.line-container input').val('').show();

    this.$el.css('overflow', '');
    this.$el.find('.btn.begin-edit').addClass('applied');

    var fontFamilyContainer = this.$el.find('.ui-dropdown-div');
    _.isEmpty(fontFamilyContainer.html()) && this.appendFontItems(fontFamilyContainer);

    this.erase().then(function () {
      $input.focus();
    });
  },

  appendFontItems: function (fontFamilyContainer) {
    _.each(INKIVE.FontsFactory.getUsableFonts(), function (font, index) {
      font.support.isDefault && fontFamilyContainer.append(
        '<a style="font-family: ' + font.family.replace(/'/g, '\\\'') + ';" data-fontid="' + index + '">' +
          font.family +
        '</a>');
    });
  },

  endEditingEvent: function (event) {
    var $input = this.$el.find('.line-container input');
    this.$el.find('.btn.begin-edit').removeClass('applied');
    this.editEndTime = new Date();

    if ($input.val()) {
      this.endTyping();
      this.trigger('change');
    } else {
      this.type(this.preEditText).then(_.bind(function () {
        this.endTyping();
      }, this));
    }
  },

  addElement: function (elementData) {
    DesignFacade.create('text', elementData);
  },

  getClickElementData: function (event) {
    var offset = this.editor.getOffset();
    var baseData = this.getBaseElementData(offset);
    var x = (offset.width - baseData['size']['width']) / 2;

    return _.extend(baseData, { position: {
      'x': Math.floor4(x),
      'y': Math.floor4((offset.height - baseData['font']['size']) / 2)
    }});
  },

  getMouseUpElementData: function (event) {
    var zoom = EditorFacade.handle('zoom', 'get');
    var offset = this.editor.getOffset();
    var bbRect = this.$draggableClone[0].getBoundingClientRect();
    var baseData = this.getBaseElementData(offset);
    var x = event.clientX - (baseData['size']['width'] / 2) * zoom - offset.x;

    return _.extend(baseData, { position: {
      'x': Math.floor4(x),
      'y': Math.floor4((bbRect.top - offset.y) / zoom)
    }});
  },

  getBaseElementData: function (offset) {
    var canvas = this.editor.canvas;
    var $text = this.$el.find('.line-container > .item .content');
    var baseSize = _.min([canvas.contentW, canvas.contentH]);
    var containerWidth = $text[0].getBoundingClientRect().width;
    var fontSize = Math.round(baseSize * this.data['size']);
    var width = containerWidth * (fontSize / 25);
    var data = this.getTextData();

    if (this.data['text_block']) {
      width = parseInt($('#svgcontent').attr('width')) / 2;
    }
    return {
      'content': data.text,
      'decoration': data.textDecoration,
      'font': {
        'family': data.fontFamily,
        'weight': data.fontWeight,
        'style': data.fontStyle,
        'size': fontSize
      },
      'size': { 'width': Math.floor4(width) }
    };
  },

  initialize: function (options) {
    _.bindAll(this, 'type', 'erase', 'refresh', 'initAccordion', 'getTextData');
    this.data = options.data;
    BaseView.prototype.initialize.call(this);
  },

  refresh: function () {
    var $options = this.$el.find('.menu.options');
    this.minimizedHeight = this.$el.find('.line-container').height();
    this.$el.height(this.minimizedHeight);
    this.fullHeight = this.minimizedHeight + $options.outerHeight();
  },

  initAccordion: function () {
    var $options = this.$el.find('.menu.options');

    this.minimizedHeight = this.$el.height();
    this.$el.height(this.minimizedHeight);
    $options.removeClass('hidden');
    this.fullHeight = this.minimizedHeight + $options.outerHeight();
    this.$draggable = this.$el.find('a.item > .content');
    this.toggleFontAvailableOptions();
  },

  render: function () {
    BaseView.prototype.render.call(this);

    this.$el.find('.fonts-list').popupmenudropdown({
      left: 0,
      onShow: _.bind(function () {
        this.$el.css('overflow', 'visible').find('.line-container input').hide();
      }, this),
      forceBottom: true
    });

    this.$el.find('.fonts-list .ui-dropdown-items').removeClass('hidden');

    var lineHeight = this.$el.find('.line-container > .item').height();
    this.$el.find('.line-container > .item').height(lineHeight);
  },

  getTemplateRenderData: function () {
    var isTextBlock = !!this.data['text_block'];
    if (isTextBlock) {
      this.data.text = INKIVE.TranslateHelper.translate('text.option_text_block');
    }

    return _.extend(this.data, {
      id: this.data['uuid'],
      font_size: this.data['font_size'] + 'px',
      fonts: [],
      options_hidden: isTextBlock
    });
  },

  type: function (text) {
    var message = text || this.data.text;
    this.typeEffect = this.typeEffect || new TypeEffect(this.$el.find('a.item'));

    return this.typeEffect.startTyping(message);
  },

  erase: function () {
    this.typeEffect = this.typeEffect || new TypeEffect(this.$el.find('a.item'));
    return this.typeEffect.startErasing();
  },

  endTyping: function () {
    this.typeEffect.hide();
    this.$el.find('.menu.options').hasClass('hidden') && this.initAccordion();
  },

  isBeingEdit: function () {
    return this.$el.find('.line-container input').is(':focus');
  },

  toggleFontAvailableOptions: function (id) {
    var $options = this.$el.find('.options');
    var fonts = INKIVE.FontsFactory.get();

    this.currentFont = id ? fonts[id] : getCurrentFont.call(this);

    if (this.currentFont) {
      $options.find('.bold-font').toggleClass('disabled', !this.currentFont.support.b);
      $options.find('.italic-font').toggleClass('disabled', !this.currentFont.support.i);
    }

    function getCurrentFont () {
      var $title = this.$el.find('.fonts-list .ui-dropdown-title');
      var currentFontFamily = $title.text();

      return INKIVE.FontsFactory.get(currentFontFamily);
    }
  },

  createDraggableClone: function () {
    var $draggableClone = BaseView.prototype.createDraggableClone.call(this);
    $draggableClone.css(_.omit(this.getTextData('-'), 'text'));

    return $draggableClone;
  },

  setTextData: function (data) {
    var $text = this.$el.find('.line-container > .item .content');
    var $options = this.$el.find('.options');

    data = humps.camelizeKeys(data);

    data.text && $text.text(data.text);
    $text.css('font-family', data.fontFamily);
    this.$el.find('.fonts-list .ui-dropdown-title').text(data.fontFamily);
    this.toggleFontAvailableOptions();

    $options.find('.bold-font a').toggleClass('applied', data.fontWeight || false);
    $text.css('font-weight', data.fontWeight);

    $options.find('.italic-font a').toggleClass('applied', data.fontStyle || false);
    $text.css('font-style', data.fontStyle);

    $options.find('.underline-font a').toggleClass('applied', data.textDecoration || false);
    $text.css('text-decoration', data.textDecoration);
  },

  getTextData: function (separator) {
    var $text = this.$el.find('.line-container > .item .content');
    var $options = this.$el.find('.options');

    var data = {
      fontFamily: this.getQuoteScaped($text.css('font-family')),
      text: $text.text() === '&nbsp;' ? this.preEditText : $text.text()
    };

    if (this.data['text_block']) {
      data.text = this.data['text_block'];
    }

    if ($options.find('.bold-font a').hasClass('applied')) {
      data.fontWeight = $text.css('font-weight');
    }

    if ($options.find('.italic-font a').hasClass('applied')) {
      data.fontStyle = $text.css('font-style');
    }

    if ($options.find('.underline-font a').hasClass('applied')) {
      data.textDecoration = $text.css('text-decoration');
    }

    if (separator) {
      return humps.decamelizeKeys(data, { separator: separator });
    }

    return data;
  }
})));
